import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class LegacyMappingService {
	constructor() {}

	getFormSettingsMapping(formId) {
		return this.formTypes.find((x) => x.id === formId);
	}

	// Don't add new ones. This is for backwards compatibility only.
	formTypes = [
		{ id: 'check-request', value: 'CheckRequest' },
		{ id: 'contract-approval', value: 'ContractApproval' },
		{ id: 'purchasing', value: 'Purchasing' },
		{ id: 'change-order', value: 'ChangeOrder' },
		{ id: 'budget-transfer', value: 'BudgetTransfer' },
		{ id: 'budget-amend', value: 'BudgetAmendment' },
		{ id: 'ap-invoice', value: 'APInvoice' },
		{ id: 'bid-form', value: 'Bid' },
		{ id: 'p-card', value: 'PCard' },
		{
			id: 'p-card',
			value: 'PCard',
		},
		{
			id: 'newproject',
			value: 'NewProjectForm',
		},
		{
			id: 'support-request',
			value: 'SupportRequestForm',
		},
		{
			id: 'timesheet',
			value: 'TimeSheet',
		},
		{
			id: 'monthly-timesheet',
			value: 'MonthlyTimeSheet',
		},
		{
			id: 'invoice-approval',
			value: 'InvoiceApproval',
		},
		{
			id: 'receipt-verification',
			value: 'ReceiptVerification',
		},
		{
			id: 'cc-approval',
			value: 'CCApproval',
		},
		{
			id: 'vendor-form',
			value: 'Vendor',
		},
		{
			id: 'business-license',
			value: 'License',
		},
		{
			id: 'capital-budget',
			value: 'CapitalBudget',
		},
		{
			id: 'operating-expense-budget',
			value: 'OperatingExpenseBudget',
		},
		{
			id: 'dpt-exp-budget',
			value: 'DepartmentExpenseBudget',
		},
		{
			id: 'fund-rev-budget',
			value: 'FundRevenueBudget',
		},
		{
			id: 'addition-form',
			value: 'AssetAdditionForm',
		},
		{
			id: 'disposal-form',
			value: 'DisposalForm',
		},
		{
			id: 'transfer-form',
			value: 'AssetTransferForm',
		},
		{
			id: 'journal-entry',
			value: 'JournalEntryForm',
		},
		{
			id: 'department-addition-form',
			value: 'DepartmentAdditionForm',
		},
		{
			id: 'fund-addition-form',
			value: 'FundAdditionForm',
		},
		{
			id: 'personnel-budget-form',
			value: 'PersonnelBudgetForm',
		},
		{
			id: 'cashiering-report',
			value: 'CashieringReport',
		},
		{
			id: 'project-mgt-2',
			value: 'ProjectManagementForm',
		},
		{
			id: 'project-close-form',
			value: 'ProjectCloseForm',
		},
		{
			id: 'project-open-form',
			value: 'ProjectOpenForm',
		},
		{
			id: 'funding-increase-form',
			value: 'FundingIncreaseForm',
		},
		{
			id: 'payment-approval-form',
			value: 'PaymentApprovalForm',
		},
		{
			id: 'lease-evaluation',
			value: 'LeaseEvaluation',
		},
		{
			id: 'user-form',
			value: 'UserWorkflowForm',
		},
		{
			id: 'gl-account',
			value: 'AccountCreationForm',
		},
		{
			id: 'application',
			value: 'Application',
		},
		{
			id: 'po-rollover-form',
			value: 'PoRolloverForm',
		},
		{
			id: 'po-rollback-form',
			value: 'PoRollbackForm',
		},
		{
			id: 'customer-form',
			value: 'CustomerForm',
		},
		{
			id: 'customer-invoice-form',
			value: 'CustomerInvoiceForm',
		},
		{
			id: 'quick-invoice-form',
			value: 'QuickInvoiceForm',
		},
		{
			id: 'quick-pay',
			value: 'QuickPayForm',
		},
		{
			id: 'project-grant-form',
			value: 'ProjectGrantForm',
		},
		{
			id: 'project-grant-task',
			value: 'ProjectGrantTask',
		},
		{
			id: 'project-grant-close-form',
			value: 'ProjectGrantCloseForm',
		},
		{
			id: 'project-grant-reopen-form',
			value: 'ProjectGrantReOpenForm',
		},
		{
			id: 'open-close-period',
			value: 'OpenClosePeriodForm',
		},
		{
			id: 'bank-reconciliation',
			value: 'BankReconciliationForm',
		},
		{
			id: 'void-reissue-form',
			value: 'VoidReissueForm',
		},
		{
			id: 'depreciation-schedule-form',
			value: 'DepreciationScheduleForm',
		},
		{
			id: 'job-application',
			value: 'JobApplication',
		},
		{
			id: 'employee-action-form',
			value: 'EmployeeActionForm',
		},
		{
			id: 'time-off-request-form',
			value: 'TimeOffForm',
		},
		{
			id: 'weekly-timesheet',
			value: 'TimeSheetForm',
		},
		{
			id: 'performance-evaluation',
			value: 'PerformanceEvaluation',
		},
		{
			id: 'benefit-enrolment-form',
			value: 'BenefitEnrolmentForm',
		},
		{
			id: 'cash-receipt-form',
			value: 'CashReceiptForm',
		},
		{
			id: 'individual-payee-form',
			value: 'IndividualPayeeForm',
		},
		{
			id: 'individual-payment-form',
			value: 'IndividualPaymentForm',
		},
		{
			id: 'new-capital-lease-form',
			value: 'NewCapitalLeaseForm',
		},
		{
			id: 'lease-modification-form',
			value: 'LeaseModificationForm',
		},
		{
			id: 'implementation-billing-ar',
			value: 'Implementation',
		},
		{
			id: 'implementation-general-ledger',
			value: 'ImplementationGL',
		},
		{
			id: 'implementation-purchasing',
			value: 'ImplementationPur',
		},
		{
			id: 'leave-balance-adjustment',
			value: 'LeaveBalanceAdjustmentForm',
		},
		{
			id: 'fieldwork-request',
			value: 'FieldWorkRequestForm',
		},
		{
			id: 'request-form',
			value: 'RequestForm',
		},
		{
			id: 'work-order-request',
			value: 'WorkOrderRequestForm',
		},
		{
			id: 'workflow-group-form',
			value: 'WorkflowGroup',
		},
		{
			id: 'ye-request',
			value: 'YeRequestForm',
		},
		{
			id: 'implementation-payment',
			value: 'ImplementationPay',
		},
		{
			id: 'customer-refund-form',
			value: 'CustomerRefundForm',
		},
		{
			id: 'new-hire-form',
			value: 'EmployeeHireForm',
		},
		{
			id: 'customer-invoice-adjustment-form',
			value: 'CustomerInvoiceAdjustmentForm',
		},
		{
			id: 'timesheet-approval-form',
			value: 'TimeSheetApprovalForm',
		},
		{
			id: 'implementation-hr',
			value: 'ImplementationHR',
		},
		{
			id: 'travel-pre-approval',
			value: 'TravelPreApprovalForm',
		},
		{
			id: 'travel-reimbursement',
			value: 'TravelReimbursementForm',
		},
		{
			id: 'reclassification-form',
			value: 'ReclassificationForm',
		},
		{
			id: 'new-customer-form',
			value: 'NewCustomerForm',
		},
		{
			id: 'new-property-form',
			value: 'NewPropertyForm',
		},
		{
			id: 'new-customer-account-form',
			value: 'CustomerAccountForm',
		},
		{
			id: 'implementation-payroll',
			value: 'ImplementationPayroll',
		},
	];
}
